import { Widget } from "@typeform/embed-react";
import { getRef, trackEvent } from "@/tracker";

export default function TypeformWidget() {
  return (
    <div className="h-[640px] w-full lg:h-[720px]" data-testid="application-typeform-embed">
      <Widget
        id="HnbNWHfS"
        style={{ width: "100%", height: "100%" }}
        hidden={{ ref: getRef() }}
        onSubmit={(data) => trackEvent("application", { response_id: data?.responseId || "" })}
      />
    </div>
  );
}
